// Modules
import { gql } from '@apollo/client'

export const UpdatePatientConfig = gql`
    mutation updatePatientConfig($key: String!, $value: StringOrNumberOrBoolean!) {
        updatePatientConfig(key: $key, value: $value) {
            status
        }
    }
`
export const Viewer = gql`
    {
        viewer {
            featureFlags {
                key
                value
            }
            name
            loginNav
            birthDate
            federalTaxId
            id
        }
    }
`

export const ViewerCIP = gql`
    {
        viewerCIP {
            id
            name
            birthDate
            limitedFlow
            isInvalid
            underage
            tokenType
        }
    }
`
